export var IQueueType;
(function (IQueueType) {
    IQueueType[IQueueType["TrackEvent"] = 0] = "TrackEvent";
    IQueueType[IQueueType["TrackLead"] = 1] = "TrackLead";
})(IQueueType || (IQueueType = {}));
